"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardView = void 0;
const views_1 = require("./views");
class CardView extends views_1.View {
    static defaultColumns(srcView, columnCount) {
        if (!srcView) {
            throw Error('cannot find the source of view');
        }
        let count = 0;
        const columns = srcView.columns.reduce((columns, column) => {
            if (column.hidden || count >= columnCount) {
                columns.push(Object.assign(Object.assign({}, column), { hidden: true }));
                return columns;
            }
            count++;
            columns.push(Object.assign({}, column));
            return columns;
        }, []);
        return columns;
    }
}
exports.CardView = CardView;
//# sourceMappingURL=card_view.js.map